// ตัวช่วยร่วมของหน้าข้อสอบ — ป้ายชื่อและการแปลงรหัสคำตอบเพื่อแสดงผลเท่านั้น
// การตรวจและคิดคะแนนจริงอยู่ฝั่ง server ที่เดียว (server/utils/examScoring.js)
import Swal from 'sweetalert2'

export const API = process.env.REACT_APP_API

export const CHOICE_LABELS = ['ก', 'ข', 'ค', 'ง', 'จ']

export const TYPE_LABELS = {
  choice: 'ปรนัย',
  truefalse: 'ใช่/ไม่ใช่',
  written: 'อัตนัย',
}

export const isObjective = (q) => q.eq_type === 'choice' || q.eq_type === 'truefalse'

// รหัสคำตอบ ('1'..'5' / 'T' / 'F' / '#' / '') -> ตัวอักษรที่คนอ่าน
export const answerLabel = (code) => {
  if (!code) return ''
  if (code === 'T') return 'ถ'
  if (code === 'F') return 'ผ'
  if (code === '#') return '#'
  const i = Number(code) - 1
  return CHOICE_LABELS[i] ?? code
}

// เฉลย '1,3' -> 'ก, ค' / '*' -> 'ยกเลิกข้อ'
export const keyLabel = (key) => {
  if (!key) return ''
  if (key === '*') return '*'
  return key.split(',').map(answerLabel).join(', ')
}

// คำตอบข้อปรนัยเรียงเป็นสตริงเดียว ("กข-ค") ไว้แสดง/แก้/เทียบ
//   readerText: ผลจากตัวอ่านกระดาษ { eq_no: '1' }
//   savedText:  คำตอบที่บันทึกแล้วจาก server { eq_no: { ea_answer: '1', ea_score } }
export const readerText = (answers, objective) => objective.map((q) => answerLabel(answers?.[q.eq_no]) || '-').join('')
export const savedText = (answers, objective) => objective.map((q) => answerLabel(answers?.[q.eq_no]?.ea_answer) || '-').join('')

export const roomLabel = (r) => `ม.${r.c_id}/${r.r_no}`

export const fmt = (n, digits = 2) => {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return '-'
  const v = Number(n)
  return Number.isInteger(v) ? String(v) : v.toFixed(digits).replace(/\.?0+$/, '')
}

export const showError = (err, title = 'ไม่สำเร็จ') => Swal.fire({
  icon: 'error',
  title,
  text: err?.response?.data?.message || err?.message || 'ลองใหม่อีกครั้ง',
})

// ปีการศึกษาที่เลือกไว้ ใช้คีย์เดียวกับหน้าอื่นของครูผู้สอน
// บางหน้าเคยเขียนค่า "undefined"/"null" ลงไป — ไม่ใช่ตัวเลขถือว่าไม่มี ไม่งั้นส่ง year_id=undefined ไปถาม server
export const readYearId = () => {
  try {
    const v = localStorage.getItem('yearId')
    return v && /^d+$/.test(v) ? v : null
  } catch {
    return null
  }
}

export const FLAG_INFO = {
  negative: { label: 'ตรวจเฉลย', variant: 'danger', help: 'คนคะแนนสูงตอบข้อนี้ผิดมากกว่าคนคะแนนต่ำ ส่วนใหญ่แปลว่าเฉลยผิด' },
  distractor: { label: 'ตัวลวงแรง', variant: 'warning', help: 'กลุ่มคะแนนสูงเลือกตัวเลือกอื่นมากกว่าเฉลย' },
  lowdisc: { label: 'จำแนกต่ำ', variant: 'warning', help: 'คนเก่งกับคนอ่อนตอบถูกพอๆ กัน ข้อนี้แยกคนสองกลุ่มไม่ออก' },
  hard: { label: 'ยากมาก', variant: 'secondary', help: 'ตอบถูกไม่ถึง 20%' },
  easy: { label: 'ง่ายมาก', variant: 'info', help: 'ตอบถูกเกิน 80%' },
  cancelled: { label: 'ยกเลิกข้อ', variant: 'dark', help: 'ทุกคนได้คะแนนข้อนี้' },
  nokey: { label: 'ยังไม่มีเฉลย', variant: 'danger', help: 'ข้อนี้ยังไม่ถูกนับคะแนนให้ใคร' },
}
